// components/ServerDatabase/PremiumBanner.jsx
import React from 'react';
import { useNavigate } from 'react-router-dom';

const PremiumBanner = () => {
  const navigate = useNavigate();

  const handleUpgradeClick = () => {
      navigate("/account", { state: { scrollTo: "plans" } });
  }

  return (
    <div className="bg-dark-600 rounded-2xl p-6 relative overflow-hidden transform-gpu hover:scale-[1.005] transition-medium border border-dark-400 hover:border-accent-purple/30">
      {/* Background effects */}
      <div className="absolute -right-20 -top-20 w-64 h-64 bg-accent-purple opacity-5 rounded-full blur-3xl"></div>
      <div className="absolute -left-20 -bottom-20 w-64 h-64 bg-accent-pink opacity-5 rounded-full blur-3xl"></div>
      
      <div className="flex flex-col md:flex-row items-center justify-between relative z-10">
        <div className="mb-6 md:mb-0">
          <h3 className="font-bold text-xl sm:text-2xl mb-2 group">
            Unlock<span className="gradient-text inline-block ml-2 group-hover:animate-pulse-text">Premium</span> Server Database
          </h3>
          <p className="text-gray-400 mb-4 max-w-md group-hover:text-gray-300 transition-medium">
            Get access to our extended database with over 10,000+ vulnerable Minecraft servers and advanced filtering options.
          </p>
          <button onClick={handleUpgradeClick} className="bg-gradient-to-r from-accent-purple to-accent-pink text-white px-6 py-3 rounded-xl hover:shadow-glow-pink active:translate-y-0.5 transform-gpu transition-medium font-medium group">
            Upgrade to Premium
            <i className="fas fa-arrow-right ml-2 group-hover:translate-x-1 transition-medium"></i>
          </button>
        </div>
        <div className="relative animate-float transform-gpu group-hover:scale-110 transition-medium">
          <div className="text-3xl sm:text-4xl font-bold">
            <span className="text-gray-400 group-hover:text-white transition-medium">10,000</span>
            <span className="gradient-text group-hover:animate-pulse-text">+</span>
          </div>
          <p className="text-gray-400 group-hover:text-gray-300 transition-medium text-center">
            Additional Servers
          </p>
          {/* Floating particles */}
          <div className="absolute -top-4 -right-4 w-16 h-16 opacity-10 bg-white rounded-full blur-xl group-hover:opacity-20 transition-medium"></div>
        </div>
      </div>
      
      {/* Database icon */}
      <div className="absolute -right-20 -bottom-20 opacity-10 group-hover:opacity-20 transition-medium animate-float transform-gpu">
        <i className="fas fa-database text-6xl sm:text-9xl"></i>
      </div>
      
      {/* Server icon */}
      <div className="absolute -left-20 -top-20 opacity-5 group-hover:opacity-10 transition-medium animate-float transform-gpu delay-300">
        <i className="fas fa-server text-6xl sm:text-9xl"></i>
      </div>
    </div>
  );
};

export default PremiumBanner;